// extracted by mini-css-extract-plugin
export default {"withdrawLink":"dvYOaOphcBuKdK4DYfDg","placeHolderShimmer":"Fi8_5hu62_4tTTH5dY1b"};